import {TelephonyLine} from '@dms/api/settings';

/** Lines whose stored routing rings this group when open; the default rule never references a group. */
export const getLinesUsingGroup = (lines: TelephonyLine[], groupId: string) =>
  lines.filter(
    (line) =>
      !line.routing.isDefault &&
      line.routing.openTarget?.kind === 'group' &&
      line.routing.openTarget.id === groupId
  );
